module.exports = __webpack_public_path__ + "static/calling-in-counseling-56a14dc26f4e733cdf1911c93f2f7406.jpg";